import { labelBarChart } from './statisticsFunctions'

/**
 * Risolve un colore semantico in token CSS del design system.
 * @param {string} color - Colore grezzo o nome semantico
 * @returns {string} Valore CSS del colore
 */
function resolveBarColor(color) {
  const map = {
    green: 'var(--success)',
    yellow: 'var(--warning)',
    orange: 'var(--warning)',
    red: 'var(--danger)'
  }
  return map[color] || color
}

/**
 * Riga percentuale con barra di progresso colorata.
 * Mostra label, conteggio e barra proporzionale al valore percentuale.
 * @param {Object} props - Proprietà del componente
 * @param {Array} props.data - Array dei dati per conteggio
 * @param {Object} props.itemLabel - Oggetto con label e colore
 * @param {Array} props.percentageStateTotal - Array con tutte le percentuali
 * @param {boolean} props.main - Se true, usa stile barra principale più grande
 * @param {string} props.overlayLabel - Label alternativa da sovrapporre
 * @param {boolean} props.noTotal - Se true, nasconde il conteggio in parentesi
 * @returns {JSX.Element} Riga percentuale con barra di progresso
 */
export const PercentageInfoNumber = ({
  data,
  itemLabel,
  percentageStateTotal,
  main,
  overlayLabel,
  noTotal
}) => {
  const { label, color } = itemLabel
  const percentage = percentageStateTotal?.find((item) => item.name === label)?.value || 0
  const displayLabel = overlayLabel || labelBarChart(label)
  const barColor = resolveBarColor(color)
  const count = data?.length || 0

  return (
    <div className={`stats-progress-row${main ? ' stats-progress-row--main' : ''}`}>
      <div className="stats-progress-labels">
        <span className="stats-progress-name">{displayLabel}</span>
        <span
          className="stats-progress-value"
          style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, color: 'var(--ink-900)' }}
        >
          {percentage}%
          {!noTotal && count > 0 && (
            <span style={{ color: 'var(--ink-500)', fontWeight: 400 }}> · {count}</span>
          )}
        </span>
      </div>
      <div className="stats-progress-track">
        <div
          className="stats-progress-fill"
          style={{
            width: `${Math.min(percentage, 100)}%`,
            background: barColor
          }}
        />
      </div>
    </div>
  )
}
